<template>
  <EditBox :name="name" :styleList="styleList" :currentStyle.sync="localStyle" :tip="`最多添加${maxCount}张图片，上传图片大小不超过2M（可拖动排序）`">
    
    <ItemSetting v-if="type === 'image'" label="图片宽(%)">
      <el-input type="number" placeholder="请输入图片宽度百分比" v-model.number="imageWidth"></el-input>
    </ItemSetting>

    <vuedraggable v-if="data && data.length" v-model="data" tag="ul" draggable="li" class="item-list">
      <li v-for="(item, index) in data" :key="index">
        <ImageCard :title="`排序${index + 1}`" :index="index" v-model="data[index]" @remove-item="removeItem" @edit-image="editImage" />
      </li>
    </vuedraggable>
    <EmptyCard v-else />

    <ButtonGroup>
      <UploadImage ref="imageUploader" :disabled="data.length >= maxCount" @upload-success="updateImage" />
    </ButtonGroup>
  </EditBox>
</template>

<script>
import vuedraggable from 'vuedraggable'
import ImageCard from "./card/ImageCard"
import UploadImage from "@/components/Upload/UploadImage"
import EditBox from "./box/EditBox"
import ItemSetting from "./setting/ItemSetting"
import EmptyCard from "./card/EmptyCard"
import ButtonGroup from "./btngroup/ButtonGroup"
import editMixin from './mixins/editMixin'

export default {
  name: 'ImageEdit',
  mixins: [editMixin],
  components: {
    vuedraggable,
    ImageCard,
    UploadImage,
    EditBox,
    ItemSetting,
    EmptyCard,
    ButtonGroup
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    styleList: {
      type: Array,
      default: () => []
    },
    currentStyle: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      maxCount: 8
    }
  },
  methods: {
    removeItem(index) {
      const newData = [...this.data]
      newData.splice(index, 1)
      this.updateValue({ data: newData })
    },
    editImage(index) {
      this.$refs.imageUploader.triggerUpload({ index })
    },
    updateImage(imgUrl, triggerParams) {
      const newData = [...this.data]
      if (triggerParams && triggerParams.index !== undefined) {
        newData[triggerParams.index] = { ...newData[triggerParams.index], url: imgUrl }
      } else {
        newData.push({ url: imgUrl, link: '' })
      }
      this.updateValue({ data: newData })
    }
  },
  computed: {
    imageWidth: {
      get() {
        return this.value.imageWidth || 0
      },
      set(val) {
        if (!val) {
          val = 0
        }
        if (val < 0 || val > 100) {
          this.$message.error('图片宽度百分比必须在0-100之间')
          return
        }
        this.updateValue({ imageWidth: val })
      }
    },
    data: {
      get() {
        return this.value.data
      },
      set(val) {
        this.updateValue({ data: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
